import {Component} from '@angular/core';

@Component({
  selector: 'mz-sidenav-header',
  templateUrl: './sidenav-header.component.html',
  styleUrls: ['./sidenav-header.component.scss'],
})
export class MzSidenavHeaderComponent {
}
